import { Box, Button } from '@mui/material';

import { wf } from './tokens';

interface IntakePageFooterProps {
  primaryLabel: string;
  onPrimary?: () => void;
  disabled?: boolean;
  onBack?: () => void;
  saveLabel?: string;
  onSave?: () => void;
  saveDisabled?: boolean;
  disabledReason?: string;
}

/** The footer every intake page shares. Group-specific help lives in its generated panel. */
export function IntakePageFooter({
  primaryLabel,
  onPrimary,
  disabled,
  onBack,
  saveLabel,
  onSave,
  saveDisabled,
  disabledReason,
}: IntakePageFooterProps) {
  const disabledReasonId = disabledReason ? 'intake-page-footer-disabled-reason' : undefined;
  return (
    <Box
      sx={{
        marginTop: 'auto',
        display: 'flex',
        justifyContent: onBack ? 'space-between' : 'flex-end',
        alignItems: 'center',
        paddingTop: '10px',
        borderTop: `1px solid ${wf.line}`,
      }}
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        {onBack && (
          <Button
            onClick={onBack}
            variant="outlined"
            sx={{
              textTransform: 'none',
              borderRadius: '7px',
              padding: '9px 16px',
              fontSize: '13px',
              fontWeight: 650,
              borderColor: wf.line,
              color: wf.ink,
            }}
          >
            ← Back
          </Button>
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {disabledReason && (
          <Box
            id={disabledReasonId}
            aria-live="polite"
            sx={{ color: 'text.secondary', fontSize: '0.8rem', maxWidth: 360 }}
          >
            {disabledReason}
          </Box>
        )}
        {saveLabel && onSave && (
          <Button onClick={onSave} disabled={saveDisabled} variant="outlined">
            {saveLabel}
          </Button>
        )}
        <Button
          onClick={onPrimary}
          disabled={disabled}
          aria-describedby={disabledReasonId}
          sx={{
            textTransform: 'none',
            borderRadius: '7px',
            padding: '9px 16px',
            fontSize: '13px',
            fontWeight: 650,
            background: wf.blue,
            color: '#fff',
            '&:hover': { background: '#24509a' },
            '&.Mui-disabled': { background: '#e9ebee', color: '#9aa0a8' },
          }}
        >
          {primaryLabel}
        </Button>
      </Box>
    </Box>
  );
}
